export default __webpack_public_path__ + "static/media/BG-LightBlue-0001.b7176642.png";